import {
  generateReport as v5GenerateReport,
  getFolders as ApiGetFolders,
  getReport,
  getRight,
  getTemplates,
  getUserProfilePhoto,
  logout as ApiLogout
} from '@/services/APIService'

export async function login ({ commit }, credentials) {
  const user = await login(credentials.username, credentials.password)
  commit('SET_USER', user)
  return user
}

export async function retrieveRights ({ commit }) {
  const res = await getRight('menu_insert')
  commit('SET_RIGHT', res)
}

export async function logout ({ commit }) {
  await ApiLogout()
  commit('SET_USER', {})
}

export async function fetchUserData ({ commit }, hash) {
  const fields = await getUserProfilePhoto(hash)
  commit('SET_PROFILE_PHOTO', fields.profile_photo)
}

// @ts-ignore
export async function retrieveTemplates ({ state, commit, rootState }, { force, type } = {}) {
  if (force || state.templates.length === 0) {
    commit('SET_TEMPLATES', await getTemplates({ type, sort: 'label' }))
  }
}

export function requestPasswordReset ({ commit }, email) {
  return new Promise<void>((resolve, reject) => {
    resolve()
  })
}

export function resetPassword ({ commit }, password) {
  return new Promise<void>((resolve, reject) => {
    resolve()
  })
}

export function validToken ({ commit }, token) {
  return new Promise((resolve, reject) => {
    resolve(true)
  })
}

export function generateV3Report ({ commit }, { fg, auth }) {
  return getReport(fg.tid, auth.authentication.uid, auth.authentication.sid)
}

export function generateReport ({ commit }, { folderHash, fh, uh, outputFormat, tn, fileName }) {
  return v5GenerateReport({ fh, fileName, uh: uh, folderId: folderHash, tn, outputFormat })
    .then(res => res.data.form)
    .catch(e => {
      console.error(e.response.data.message[0] || e)
      throw new Error(e.response.data.message[0])
    })
}

/**
 * @param context supplied by Vuex
 * @param formhash required; used by api to retrieve report-templates even if your user-group is no longer connected to the form-template.
 */
export function fetchReportTemplates (context, { fh, parent }): Promise<Object[]> {
  return getTemplates({ fh, parent, type: 'report', sort: 'label' })
}

export function getFolders ({ commit }, uh) {
  return ApiGetFolders(uh)
}
